import { DateTime } from "luxon";
import StackTrace from "stacktrace-js";
import { without } from "./lodash";

declare const Voxco;

export const MAX_LINES = 2048;
export const LOG_BUFFER = [];

const DEFAULT_LOG_LEVEL = 3;
const TEST_LOG_LEVEL = 0;
const DEV_LOG_LEVEL = 4; // Change to 6 to log everything.
const LOG_LEVELS = ["e", "w", "i", "d", "v", "_"];

export type LogListener = (
    date: Date,
    severity: string,
    tag: string,
    event: string,
    msg: string,
) => void;

let _listeners: LogListener[] = [];
export const addOnLogListener = (listener: LogListener) => (_listeners = [..._listeners, listener]);
export const removeOnLogListener = (listener: LogListener) =>
    (_listeners = without(_listeners, listener));

// tslint:disable:no-console
function log(date: Date, severity: string, tag: string, event: string, msg: string, error?: any) {
    let logLevel = DEFAULT_LOG_LEVEL;
    if (process.env.NODE_ENV === "test") logLevel = TEST_LOG_LEVEL;
    if (process.env.NODE_ENV === "development") logLevel = DEV_LOG_LEVEL;
    if (error && process.env.NODE_ENV === "development") {
        StackTrace.fromError(error).then((stackframes) => {
            const mapped = `${error.name}: ${error.message}\n${stackframes
                .map((sf) => `    at ${sf.toString()}`)
                .join("\n")}`;
            log(date, severity, tag, event, mapped);
        });
        return;
    }
    if (LOG_LEVELS.indexOf(severity) >= logLevel) return;
    LOG_BUFFER.push({ date, severity, tag, event, msg, error });
    console.log(
        `${DateTime.fromJSDate(date).toFormat("HH:mm:ss")} ${severity.toUpperCase()}/${tag} ${
            event || ""
        } ${msg || ""}`.trim(),
    );
    if (error) console.error(error.stack);
    _listeners.forEach((l) => l(date, severity, tag, event, msg));
}

export const Log = {
    _: (tag: string, event: string, msg?: string) => log(new Date(), "_", tag, event, msg),
    v: (tag: string, event: string, msg?: string) => log(new Date(), "v", tag, event, msg),
    d: (tag: string, event: string, msg?: string) => log(new Date(), "d", tag, event, msg),
    i: (tag: string, event: string, msg?: string) => log(new Date(), "i", tag, event, msg),
    w: (tag: string, event: string, msg?: string) => log(new Date(), "w", tag, event, msg),
    e: (tag: string, event: string, msg?: string, error?: any) =>
        log(new Date(), "e", tag, event, msg, error),
};

if (typeof Voxco !== "undefined")
    Log.i("logging", "INITIALIZED", `Initialized SurveyEngineJS v${Voxco.version}`);
